<div class="preferences-container">
  <!-- Options List -->
  <div class="options-sidebar">
    <div class="sidebar-header">
      <label>{{'FILE_MENU_OPPORTUNITY' | translate}}</label>
    </div>

    <mat-list class="options-list">
      <mat-list-item
        (click)="selectOption(opportunityOptionId.CREATE_NEW, isCreateDisabled)"
        [class.selected]="selectedOptionId === opportunityOptionId.CREATE_NEW"
        [class.disabled]="isCreateDisabled"
        class="option-item">
        <div matListItemTitle>{{'CREATE_NEW' | translate}}</div>
      </mat-list-item>

      <mat-list-item
        (click)="selectOption(opportunityOptionId.LINK_UNLINK, isLinkUnlinkDisabled)"
        [class.selected]="selectedOptionId === opportunityOptionId.LINK_UNLINK"
        [class.disabled]="isLinkUnlinkDisabled"
        class="option-item">
        <div matListItemTitle>{{'INFORMATION_LINK_UNLINK' | translate}}</div>
      </mat-list-item>
    </mat-list>
  </div>

  <!-- Content Area -->
  <div class="content-area">
    <div class="content-header">
      <div class="header-info">
        <label>{{getSelectedOptionLabel() | translate}}</label>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="content-body">
      @switch (selectedOptionId) {
        @case (opportunityOptionId.CREATE_NEW) {
          <app-create-opportunity [isCollaborativeReadOnly]="isCollaborativeReadOnly" (cancel)="onCancel()"></app-create-opportunity>
        }
        @case (opportunityOptionId.LINK_UNLINK) {
          <app-information-link-unlink [isCollaborativeReadOnly]="isCollaborativeReadOnly" (cancel)="onCancel()"></app-information-link-unlink>
        }
      }
    </div>
  </div>
</div>
